module.exports = __webpack_public_path__ + "media/night/374-f98d7d49.svg";